import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
export var Count = function Count(_ref) {
  var count = _ref.count,
      hideIfEmpty = _ref.hideIfEmpty,
      dataTest = _ref['data-test'];
  return hideIfEmpty && count < 1 ? null : /*#__PURE__*/React.createElement("span", {
    "data-test": dataTest
  }, count);
};
export function getWishlistCount(state) {
  if (state !== null && state !== void 0 && state.userDetails) {
    var _state$userDetails, _state$userDetails$da;

    var list = ((_state$userDetails = state.userDetails) === null || _state$userDetails === void 0 ? void 0 : (_state$userDetails$da = _state$userDetails.data) === null || _state$userDetails$da === void 0 ? void 0 : _state$userDetails$da.userState) === 'LOGGEDIN' ? state.globalList : state.localList;
    var _list$data = list.data,
        data = _list$data === void 0 ? {} : _list$data;
    var _data$wishlists = data.wishlists,
        wishlists = _data$wishlists === void 0 ? [] : _data$wishlists;

    var _ref2 = wishlists.length && wishlists[0] || {},
        _ref2$items = _ref2.items,
        items = _ref2$items === void 0 ? [] : _ref2$items; // Filter out items with the deleted flag


    return items.reduce(function (total, item) {
      return item.deleted ? total : total + 1;
    }, 0);
  }

  return 0;
}

function mapStateToProps(state) {
  var count = getWishlistCount(state);
  return {
    count: count
  };
}

Count.propTypes = {
  count: PropTypes.number,
  hideIfEmpty: PropTypes.bool,
  'data-test': PropTypes.string
};
Count.defaultProps = {
  'data-test': 'component-atw-count'
};
export default connect(mapStateToProps)(Count);